import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "quality-settings" }
const _hoisted_2 = { class: "quality-settings__header" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "quality-settings__panel" }
const _hoisted_5 = {
  key: 0,
  class: "quality-settings__empty"
}
const _hoisted_6 = { class: "quality-settings__grid" }
const _hoisted_7 = ["onUpdate:modelValue", "type", "step"]
const _hoisted_8 = { class: "quality-settings__field quality-settings__field--toggle" }
const _hoisted_9 = { class: "quality-settings__note" }
const _hoisted_10 = { class: "quality-settings__panel" }
const _hoisted_11 = { class: "quality-settings__table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[3] || (_cache[3] = _createElementVNode("h2", null, "质量阈值", -1)),
        _createElementVNode("p", null, "当前版本 v" + _toDisplayString(_ctx.current?.version || '-') + "。保存会创建新版本，已领取任务继续使用领取时快照。", 1)
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "quality-settings__save",
        disabled: _ctx.loading || _ctx.saving,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.saveThresholds && _ctx.saveThresholds(...args)))
      }, _toDisplayString(_ctx.saving ? '保存中...' : '保存新版本'), 9, _hoisted_3)
    ]),
    _createElementVNode("section", _hoisted_4, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, "加载中..."))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (field) => {
                return (_openBlock(), _createElementBlock("label", {
                  key: field.key,
                  class: "quality-settings__field"
                }, [
                  _createElementVNode("span", null, _toDisplayString(field.label), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": ($event: any) => ((_ctx.form[field.key]) = $event),
                    type: field.type,
                    step: field.step
                  }, null, 8, _hoisted_7), [
                    [_vModelDynamic, _ctx.form[field.key]]
                  ]),
                  _createElementVNode("small", null, _toDisplayString(field.hint), 1)
                ]))
              }), 128)),
              _createElementVNode("label", _hoisted_8, [
                _cache[4] || (_cache[4] = _createElementVNode("span", null, "生产 OCR 硬依赖", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.requireContentOcr) = $event)),
                  type: "checkbox"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.requireContentOcr]
                ]),
                _cache[5] || (_cache[5] = _createElementVNode("small", null, "开启后 builtin-ink 或空 OCR 文本会质量失败", -1))
              ])
            ]),
            _createElementVNode("label", _hoisted_9, [
              _cache[6] || (_cache[6] = _createElementVNode("span", null, "版本备注", -1)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.note) = $event)),
                rows: "3",
                placeholder: "说明这次阈值调整原因"
              }, null, 512), [
                [_vModelText, _ctx.note]
              ])
            ])
          ], 64))
    ]),
    _createElementVNode("section", _hoisted_10, [
      _cache[8] || (_cache[8] = _createElementVNode("h3", null, "历史版本", -1)),
      _createElementVNode("table", _hoisted_11, [
        _cache[7] || (_cache[7] = _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, "版本"),
            _createElementVNode("th", null, "Profile"),
            _createElementVNode("th", null, "文本覆盖"),
            _createElementVNode("th", null, "Visual Diff"),
            _createElementVNode("th", null, "创建时间"),
            _createElementVNode("th", null, "备注")
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.history, (item) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: item.id
            }, [
              _createElementVNode("td", null, "v" + _toDisplayString(item.version), 1),
              _createElementVNode("td", null, _toDisplayString(item.thresholds.profile || '-'), 1),
              _createElementVNode("td", null, _toDisplayString(item.thresholds.min_text_coverage), 1),
              _createElementVNode("td", null, _toDisplayString(item.thresholds.max_visual_diff_ratio), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.formatDateTime(item.created_at)), 1),
              _createElementVNode("td", null, _toDisplayString(item.note || '-'), 1)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}